import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { Table } from "antd";
const ConsignmentCumulativeFreightTable = (props) => {
    const formatQty = (qty) => {
        if (qty) { // Don't show "0" values (which is falsy) this is not the same behaviour as <ValOrDash />
            return qty;
        }
        return _jsx(_Fragment, { children: "\u2014" });
    };
    return (_jsx(Table, { columns: [
            {
                title: 'Description',
                dataIndex: 'productDescription',
            },
            {
                title: 'Assigned',
                render: (row) => {
                    return formatQty(row.totalOrderedQuantity);
                },
                align: 'right'
            },
            {
                title: 'In Transit',
                render: (row) => {
                    return formatQty(row.totalInTransitQuantity);
                },
                align: 'right'
            }, {
                title: 'Delivered',
                render: (row) => {
                    return formatQty(row.totalDeliveredQuantity);
                },
                align: 'right'
            },
            {
                title: 'UOM',
                dataIndex: 'unitOfMeasureDescription'
            }
        ], dataSource: props.cumulativeTotals, pagination: false }));
};
export default ConsignmentCumulativeFreightTable;
